/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateSuggestion} from '../api'

export const useMutationUpdateSuggestion = createReactQueryMutationHook('updateSuggestion', updateSuggestion)
